<template>
  <app-modal
    modal-alignment="top"
    modal-id="deal-modal"
    modal-size="large"
    @close-modal="closeModal"
  >
    <template slot="header">
      <h5 v-if="selectedUrl" class="modal-title">{{ $t("edit_deal") }}</h5>
      <h5 v-else class="modal-title">{{ $t("add_deal") }}</h5>
      <button
        aria-label="Close"
        class="close outline-none"
        data-dismiss="modal"
        type="button"
      >
        <span>
          <app-icon :name="'x'"></app-icon>
        </span>
      </button>
    </template>
    <template slot="body">
      <form
        v-if="dataLoaded"
        ref="form"
        :data-url="selectedUrl ? selectedUrl : `crm/deals`"
      >
			
			
		<template v-if="componentType =='deal'">
          <div class="form-group">
            <div class="form-row">
              <label class="mb-0 col-sm-3 d-flex align-items-center">{{
                  $t("lead_type")
                }}</label>
              <div class="col-sm-9">
                <app-input
                  v-model="formData.lead_type"
                  :list="[{id:1, value: 'Персона'}, {id:2, value: 'Организация'}, {id:3, value: 'Фонд'}]"
                  :required="true"
                  type="radio"
                  @change="changeLeadType"/>
                <p
                  v-if="errors.lead_type"
                  class="text-danger"
                  style="font-size: 12px"
                >
                  {{ errors.lead_type[0] }}
                </p>
              </div>
            </div>
          </div>
        </template>	
		<div class="form-group">
          <div class="form-row">
            <label class="mb-0 col-sm-3 d-flex align-items-center">{{
                $t("pipeline")
              }}</label>
            <div class="col-sm-3">
              <app-input
                v-model="formData.pipeline_id"
                :list="pipelineList"
                :required="true"
                type="select"
              />
              <p
                v-if="errors.pipeline_id"
                class="text-danger"
                style="font-size: 12px"
              >
                {{ errors.pipeline_id[0] }}
              </p>
            </div>
			<template v-if="PiplineSetEx == 1 && formData.lead_type == 1">
			<div class="col-sm-1"></div>
			<label class="mb-0 col-sm-1 d-flex align-items-center">{{
                $t("Qty")
              }}</label>
            <div class="col-sm-1">
			<app-input
                  v-model="formData.qty"
                  :list="QtyList"
                  :required="true"
                  type="select"/>
            </div>
			<div class="col-sm-1"></div>
			<label class="mb-0 col-sm-1 d-flex align-items-center">{{
                $t("VIP")
              }}</label>
            <div class="col-sm-1 mt-2">
			<app-input
                    type="single-checkbox"
                    :list-value-field="$t(' ')"
                    v-model="formData.activity_done" />
            </div>
			</template>
          </div>
          </div>
        </div>
		 <div class="form-group">
          <div class="form-row">
            <label class="mb-0 col-sm-3 d-flex align-items-center">{{
                $t("stages")
              }}</label>
            <div class="col-sm-9">
              <component
                :is="'app-step-input-selector-new'"
                v-if="pipelineChange"
                v-model="formData.stage_id"
                :required="true"
                :step-complete="stageIndexAsId"
                :step-lists="stageListAsPipelineId"
                @stepChanges="setStageId"
              />
              <p
                v-if="errors.stage_id"
                class="text-danger"
                style="font-size: 12px"
              >
                {{ $t("this_field_is_required") }}
              </p>
            </div>
          </div>
        </div>
		
		<div class="form-group" v-if="PiplineSet == 1 && formData.lead_type == 1">
          <div class="form-row">
            <label class="mb-0 col-sm-3 d-flex align-items-center">{{
                $t("sex")
              }}</label>
            <div class="col-sm-3">
             <app-input
                  type="select"
                  list-value-field="name"
                  :list="GenList"
                  :placeholder="$t('choose_gender')"
                  v-model="formData.sex"
                  :error-message="$errorMessage(errors, 'sex')"
              />
            </div>
			<div class="col-sm-1"></div>
			<label class="mb-0 col-sm-2 d-flex align-items-center">{{
                $t("age")
              }}</label>
            <div class="col-sm-3">
             <app-input
                  type="select"
                  list-value-field="name"
                  :list="AgeList"
                  :placeholder="$t('choose_age')"
                  v-model="formData.age"
                  :error-message="$errorMessage(errors, 'age')"
              />
            </div>
          </div>
        </div>
		
		 
				  
				  
				  
        <div class="form-group" v-if="PiplineSet != 1 && formData.lead_type == 1">
          <div class="form-row">
            <label class="mb-0 col-sm-3 d-flex align-items-center">{{
                $t("title")
              }}</label>
            <div class="col-sm-9">
              <app-input
                v-model="formData.title"
                :placeholder="$t('enter_deal_title')"
                :error-message="$errorMessage(errors, 'title')"
                type="text"
              />
            </div>
          </div>
        </div>
		<div class="form-group" v-if="formData.lead_type != 1">
          <div class="form-row">
            <label class="mb-0 col-sm-3 d-flex align-items-center">{{
                $t("title")
              }}</label>
            <div class="col-sm-9">
              <app-input
                v-model="formData.title"
                :placeholder="$t('enter_deal_title')"
                :error-message="$errorMessage(errors, 'title')"
                type="text"
              />
            </div>
          </div>
        </div>
	
        
		<template v-if="formData.lead_type == 3 && componentType == 'deal'">
          <div class="form-group">
            <div class="form-row">
              <label class="mb-0 col-sm-3 d-flex align-items-center">{{
                  $t("fund")
                }}</label>
              <div class="col-sm-9">
                <app-input
                  v-model="formData.contextable_id"
                  :list="pfundList"
                  :placeholder="$t('choose_fund')"
                  :error-message="$errorMessage(errors, 'contextable_id')"
                  list-value-field="name"
                  type="search-select"
                />
              </div>
            </div>
          </div>
        </template>
        <template v-if="formData.lead_type == 1 && componentType == 'deal' && PiplineSet != 1">
          <div class="form-group">
            <div class="form-row">
              <label class="mb-0 col-sm-3 d-flex align-items-center">
				   <template v-if="formData.pipeline_id == 7">
					   {{$t("personex")}}
					   </template>
				  <template v-else>
					  {{$t("person")}}
					   </template>
				  
				</label>
              <div class="col-sm-9">
                <app-input
                  v-model="formData.contextable_id"
                  :list="personList"
                  :placeholder="$t('choose_a_contact_person')"
                  :error-message="$errorMessage(errors, 'contextable_id')"
                  list-value-field="name"
                  type="search-select"
                />
              </div>
            </div>
          </div>
        </template>
		

        <template v-if="formData.lead_type == 2 && componentType == 'deal'">
          <template v-if="componentType != 'person'">
          <template v-if="componentType != 'org'">
          <div class="form-group">
            <div class="form-row">
              <label class="mb-0 col-sm-3 d-flex align-items-center">{{
                  $t("organization")
                }}</label>
              <div class="col-sm-9">
                <app-input
                  v-model="formData.contextable_id"
                  :list="organizationList"
                  :placeholder="$t('choose_an_organization')"
                  :error-message="$errorMessage(errors, 'contextable_id')"
                  list-value-field="name"
                  type="search-select"
                />
              </div>
            </div>
          </div>
          </template>
          <div class="form-group">
            <div class="form-row">
              <label class="mb-0 col-sm-3 d-flex align-items-center">{{
                  $t("contact_person")
                }}</label>
              <div class="col-sm-9">
                <app-input
                  v-model="formData.person_id"
                  :list="personListAsOrg"
                  :placeholder="$t('choose_a_contact_person')"
                  list-value-field="name"
                  type="search-select"
                />
                <p
                  v-if="formData.contextable_id && personListAsOrg.length < 1"
                  class="text-danger"
                  style="font-size: 12px"
                >
                  {{ $t('organization_has_no_contact_person') }}
                </p>
              </div>
            </div>
          </div>
          </template>
        </template>

        <div v-if="PiplineSet != 1" class="form-group">
          <div class="form-row">
            <label class="mb-0 col-sm-3 d-flex align-items-center">{{
                $t("deal_value")
              }}</label>
            <div class="col-sm-9">
              <app-input
                v-model="formData.value"
                :placeholder="$t('enter_deal_value')"
                type="number"
              />
            </div>
          </div>
        </div>
		
		<template v-if="PiplineSet == 1 && formData.lead_type == 1">
		<div class="form-group">
          <div class="form-row">
            <label class="mb-0 col-sm-3 d-flex align-items-center">{{ $t("gid")}}</label>
            <div class="col-sm-3">
              <app-input
                  v-model="formData.gid"
                  :list="GidList"
                  :required="true"
                  type="select"/>
            </div>
			<div class="col-sm-1"></div>
			 <label class="mb-0 col-sm-2 d-flex align-items-center">{{ $t("vis")}}</label>
            <div class="col-sm-3">
              <app-input
                  v-model="formData.vis"
                  :list="VisList"
                  :required="true"
                  type="select"/>
            </div>
          </div>
        </div>
		<div class="form-group">
          <div class="form-row">
            <label class="mb-0 col-sm-3 d-flex align-items-center">{{ $t("traf")}}</label>
            <div class="col-sm-3">
              <app-input
                  v-model="formData.traf"
                  :list="TrafList"
                  :required="true"
                  type="select"/>
            </div>
			<div class="col-sm-1"></div>
			<label class="mb-0 col-sm-2 d-flex align-items-center">{{ $t("pay_id")}}</label>
            <div class="col-sm-3">
              <app-input
                  v-model="formData.pay_id"
                  :list="PayList"
                  :required="true"
                  type="select"/>
            </div>
          </div>
        </div>
        </template>
							
       
        
        
        <template v-if="customFields.length && customFieldDataLoaded">
        <div v-for="(field, index) in customFields" :key="index"
             class="form-group">
          <div class="row">
            <div class="col-md-3">
              <label>{{ field.name }}</label>
            </div>
            <div class="col-md-9">
              <template v-if="field.custom_field_type.name === 'text'">
                <app-input
                  :id="field.name"
                  v-model="customFieldValue[field.name]"
                  :list="generateInputList(field)"
                  type="text"
                />
              </template>
              <template v-if="field.custom_field_type.name === 'textarea'">
                <app-input
                  :id="field.name"
                  v-model="customFieldValue[field.name]"
                  :list="generateInputList(field)"
                  type="textarea"
                />
              </template>
              <template v-if="field.custom_field_type.name === 'radio'">
                <app-input
                  v-model="customFieldValue[field.name]"
                  :list="generateInputList(field)"
                  :radio-checkbox-name="field.name"
                  type="radio"
                />
              </template>
              <template v-if="field.custom_field_type.name === 'checkbox'">
                <app-input
                  v-model="customFieldValue[field.name]"
                  :list="generateInputList(field)"
                  :radio-checkbox-name="field.name"
                  type="checkbox"
                />
              </template>
              <template v-if="field.custom_field_type.name === 'select'">
                <app-input
                  v-model="customFieldValue[field.name]"
                  :list="generateInputList(field)"
                  type="select"
                />
              </template>
              <template v-if="field.custom_field_type.name === 'number'">
                <app-input
                  v-model="customFieldValue[field.name]"
                  type="number"
                />
              </template>
              <template v-if="field.custom_field_type.name === 'date'">
                <app-input v-model="customFieldValue[field.name]" type="date"/>
              </template>
            </div>
          </div>
        </div>
        </template>
      </form>
      <app-overlay-loader v-else/>
    </template>
    <template slot="footer">
      <button
        class="btn btn-secondary mr-2"
        data-dismiss="modal"
        type="button"
        @click.prevent="closeModal"
      >
        {{ $t("cancel") }}
      </button>
      <button class="btn btn-primary" type="button" @click.prevent="submit">
        <span class="w-100">
          <app-submit-button-loader v-if="loading"></app-submit-button-loader>
        </span>
        <template v-if="!loading">{{ $t("save") }}</template>
      </button>
    </template>
  </app-modal>
</template>
<script>

import {FormMixin} from "@core/mixins/form/FormMixin";
import {api} from "@app/Helpers/api";
import {collect} from "@app/Helpers/Collection";
import {mapGetters} from "vuex";
import {getAllCustomFields} from "@app/Mixins/Global/CustomFieldMixin";

export default {

  name: "DealModal",
  mixins: [FormMixin, getAllCustomFields],
  props: {
    preSelectedOption: Object,
    selectedUrl: String,
    tableId: String,
    pipelineId: Number,
    selectedStageIndex: Number,
    componentType: {
      type: String,
      default: 'deal'
    },
    selectedUrlId:{
      type:Number,
      default: null
    }
  },
  data() {
    return {
      formData: {
        owner_id: user.id,
		  qty: "1",
		  stage_id: "1",
		  sex: "2",
		  age: "4",
		  gid: "1",
		  traf: "1",
		  vis: "1",
		  pay_id: "1",
        pipeline_id: this.pipelineId,
		lead_type: this.componentType == 'fund' ? 3 : (this.componentType == 'org' ? 2 : 1) ,
        contextable_id: this.selectedUrlId ?? null
      },
      addEditData: {},
	  addEditDataEx: {},
      contactTypeList: [],
	  QtyList: [
	  		 	{ id: "1", value: "1",},
				{ id: "2", value: "2",},
				{ id: "3", value: "3",},
				{ id: "4", value: "4",},
				{ id: "5", value: "5",},
				{ id: "6", value: "6",},
				{ id: "7", value: "7",},
				{ id: "8", value: "8",},
				{ id: "9", value: "9",},
				{ id: "10", value: "10",},
		  		{ id: "11", value: "11",},
		  		{ id: "12", value: "12",},
		  		{ id: "13", value: "13",},
		  		{ id: "14", value: "14",},
		  		{ id: "15", value: "15",},
		  		{ id: "16", value: "16",},
		  		{ id: "17", value: "17",},
		  		{ id: "18", value: "18",},
		  		{ id: "19", value: "19",},
		  		{ id: "20", value: "20",},
		  		{ id: "21", value: "21",},
		  		{ id: "22", value: "22",},
		  		{ id: "23", value: "23",},
		  		{ id: "24", value: "24",},
		  		{ id: "25", value: "25",},
		  		{ id: "26", value: "26",},
		  		{ id: "27", value: "27",},
		  		{ id: "28", value: "28",},
		  		{ id: "29", value: "29",},
		  		{ id: "30", value: "30",},

	  		],
	  TrafList: [
	  		 	{ id: "1", value: "Рекомендация",},
				{ id: "2", value: "Интернет",},
				{ id: "3", value: "Facebook",},
				{ id: "4", value: "Instagram",},
		  		{ id: "5", value: "Месенджер",},
	  		],
	  PayList: [
	  		 	{ id: "1", value: "Наличными",},
				{ id: "2", value: "Картой",},
		  		{ id: "3", value: "Безнал",},
	  		],
	  VisList: [
	  		 	{ id: "1", value: "1-й раз",},
				{ id: "2", value: "Постоянный",},
	  		],
	  GidList: [
	  		 	{ id: "1", value: "Без аудиогида",},
				{ id: "2", value: "Русский",},
				{ id: "3", value: "Украинский",},
				{ id: "4", value: "Английский",},
				{ id: "5", value: "Китайский",},
	  		],
	  AgeList: [
	  		 { name: "0-5", id: "1", },
			 { name: "5-16", id: "2", },
			 { name: "16-25", id: "3", },
			 { name: "25-40", id: "4", },
			 { name: "40-60", id: "5", },
			 { name: "Пенсионер", id: "6", },
	  ],
	   GenList: [
	  		 { name: "Мужской", id: "1", },
			 { name: "Женский", id: "2", },
	  ],
		
      pipelineList: [],
      stageList: [],
      stageId: {},
      errors: [],
      dataLoaded: false,
      loading: false,
      pipelineChange: true,
      customFieldValue:[],
    };
  },
  computed: {
	 
	  
    personListAsOrg() {
      return this.personList.filter((item) =>
        item.organizations.find(el =>
          el.id == this.formData.contextable_id
        )
      );
    },
    stageListAsPipelineId() {
      this.loadStepInput();
      return this.stageList.filter(
        (v) => v.pipeline_id == this.formData.pipeline_id
      );
    },
	  
	filteredLastItem() {
		var koho = this.formData.stage_id;
		var goho = this.stageList.filter(function(elem){
    			if(elem.id == koho) return elem.name;
			});
		  return goho[0].probability;
    },
	filteredLastItemName() {
		var koho = this.formData.stage_id;
		var goho = this.stageList.filter(function(elem){
    			if(elem.id == koho) return elem.name;
			});
		  return goho[0].name;
    },
	  
	filteredPipl() {
		var poho = this.formData.pipeline_id;
		var noho = this.pipelineList.filter(function(elem){
    			if(elem.id == poho) return elem.name;
			});
		  return noho[0].name;
    },
	  
	PiplineSet() {
		if(this.formData.pipeline_id == 1){
			var pili = 1;
		} else if(this.formData.pipeline_id == 5){
			var pili = 1;
		} else if(this.formData.pipeline_id == 6){
			var pili = 1;
		} else if(this.formData.pipeline_id == 8){
			var pili = 1;
		} else {
			var pili = 2;
		}
		return pili;
    },
	PiplineSetEx() {
		if(this.formData.pipeline_id == 1){
			var pili = 1;
		} else if(this.formData.pipeline_id == 5){
			var pili = 1;
		} else if(this.formData.pipeline_id == 6){
			var pili = 1;
		} else if(this.formData.pipeline_id == 7){
			var pili = 1;
		} else if(this.formData.pipeline_id == 8){
			var pili = 1;
		} else {
			var pili = 2;
		}
		return pili;
    },
	
	  
	  
    stageIndexAsId() {
      let index = undefined;
      let stageListByPipeLine = this.stageList.filter(
        (v) => v.pipeline_id == this.formData.pipeline_id
      );
      for (let i = 0; i < stageListByPipeLine.length; i++) {
        if (stageListByPipeLine[i].id === this.formData.stage_id) {
          index = i;
        }
      }
      return index;
    },

    ...mapGetters({
      ownerList: "getOwner",
      organizationList: "getOrganization",
      personList: "getPerson",
		pfundList: "getFund",
      dealList: "getDeal",
    }),
  },
  created() {
	  this.$store.dispatch('getFund');
	 this.getData();
    //preSelectedOption are set in here
    if (this.preSelectedOption) {
      if (this.preSelectedOption.organization_id) {
        this.formData.organization_id = this.preSelectedOption.organization_id;
      }
      if (this.preSelectedOption.person_id) {
        this.formData.person_id = this.preSelectedOption.person_id;
      }
	 if (this.preSelectedOption.fund_id) {
        this.formData.fund_id = this.preSelectedOption.fund_id;
      }
    }
    //end of preSelectedOption set
    this.getPipeline();
    this.getStages();
    this.getAllCustomFields("deal");
    this.$nextTick(() => {
      if (this.$props.selectedStageIndex != undefined) {
        this.formData.stage_id = this.$props.selectedStageIndex;
      }
    });
  },
  methods: {
	  
	   getData() {
      this.axiosGet(`admin/app/settings`).then(response => {
        this.appSettings = response.data;

      }).catch(({error}) => {
      });
    },
		
    loadStepInput() {
      this.pipelineChange = false;
      this.$nextTick(() => {
        this.pipelineChange = true;
      });
    },
    beforeSubmit() {
      this.loading = true;
    },
    submit() {
      let customData = [];
      this.customFields.map((el) => {
        if (this.customFieldValue[el.name]) {
          let item = {
            value:
              el.custom_field_type.name == "checkbox"
                ? el.meta.split(",").filter((e, i) => {
                  if (
                    this.customFieldValue[el.name].includes(String(i)) ||
                    this.customFieldValue[el.name].includes(i)
                  ) {
                    return e;
                  }
                })
                : el.custom_field_type.name == "select" ||
                el.custom_field_type.name == "radio"
                ? el.meta.split(",").find((e, i) => {
                  return i == Number(this.customFieldValue[el.name]);
                })
                : this.customFieldValue[el.name],
            custom_field_id: el.id,
          };

          customData.push(item);
        }
      });
		if(this.PiplineSet == 1){
			this.addEditData.traf = this.formData.traf;
			this.addEditData.vis = this.formData.vis;
			this.addEditData.pay_id = this.formData.pay_id;
			this.addEditData.gid = this.formData.gid;
			this.addEditData.sex = this.formData.sex;
			this.addEditData.age = this.formData.age;
		}else{
			this.addEditData.traf = null;
			this.addEditData.vis = null;
			this.addEditData.pay_id = null;
			this.addEditData.gid = null;
			this.addEditData.sex = null;
			this.addEditData.age = null;
		}
		
		
		
      this.addEditData.person_id = this.formData.person_id;
		this.addEditData.fund_id = this.formData.fund_id;
		
      if (this.formData.lead_type == 1) {
		  this.addEditData.person_id = this.formData.contextable_id;
	  }
	  if (this.formData.lead_type == 3) {
        this.addEditData.fund_id = this.formData.contextable_id;
      }
	  this.addEditData.lead_type = this.formData.lead_type;
      this.addEditData.customs = customData;
		
		
	  if (this.PiplineSet == 1) {
		  this.addEditData.title = this.filteredPipl + ' - ' + this.filteredLastItemName;
	  }else{
		  this.addEditData.title = this.formData.title;
	  }
      
		
	  if (this.PiplineSet == 1) {
		if(this.formData.sex == "2" && this.formData.age == "4"){
			  this.addEditData.contextable_id = 100001;
		} else if(this.formData.sex == "2" && this.formData.age == "3"){
			  this.addEditData.contextable_id = 100002;
		} else if (this.formData.sex == "2" && this.formData.age == "5"){
			  this.addEditData.contextable_id = 100003;
		} else if (this.formData.sex == "2" && this.formData.age == "2"){
			  this.addEditData.contextable_id = 100005;
        } else if (this.formData.sex == "2" && this.formData.age == "1"){
			  this.addEditData.contextable_id = 100006;
		} else if (this.formData.sex == "2" && this.formData.age == "6"){
			  this.addEditData.contextable_id = 100004;
		} else if (this.formData.sex == "1" && this.formData.age == "1"){
			  this.addEditData.contextable_id = 100007;
		} else if (this.formData.sex == "1" && this.formData.age == "2"){
			  this.addEditData.contextable_id = 100008;
		} else if (this.formData.sex == "1" && this.formData.age == "3"){
			  this.addEditData.contextable_id = 100009;
		} else if (this.formData.sex == "1" && this.formData.age == "4"){
			  this.addEditData.contextable_id = 100010;
		} else if (this.formData.sex == "1" && this.formData.age == "5"){
			  this.addEditData.contextable_id = 100011;
		} else if (this.formData.sex == "1" && this.formData.age == "6"){
			  this.addEditData.contextable_id = 100012;
		  }
	  } else {
	    this.addEditData.contextable_id = this.formData.contextable_id;
	  }

		this.addEditData.stage_id = this.formData.stage_id;
		
		if(this.PiplineSet == 1){
			
			if(this.formData.pay_id == 2){
			   		this.addEditData.value = this.filteredLastItem - (this.filteredLastItem * this.appSettings.card / 100);
			   }else if(this.formData.pay_id == 3){
					this.addEditData.value = this.filteredLastItem - (this.filteredLastItem * this.appSettings.liq / 100);
			   }else{
			   		this.addEditData.value = this.filteredLastItem;
			   }
		

		}else{
			this.addEditData.value = this.formData.value;
		}
		
		
		
		
		
		if(this.formData.pipeline_id == 7){
			this.addEditData.contextable_id = 100019;
			this.addEditData.traf = 6;
			this.addEditData.value = this.formData.value / this.formData.qty;
			this.addEditData.title = this.filteredPipl + ' - ' + this.filteredLastItemName;
		}
		
		
		this.addEditDataEx.contextable_id = this.formData.contextable_id;
		this.addEditDataEx.title = 'Гид (' + this.formData.title + ')';
		this.addEditDataEx.contextable_type = 'App\Models\CRM\Person\Person';
		this.addEditDataEx.pipeline_id = this.formData.pipeline_id;
		this.addEditDataEx.stage_id = this.formData.stage_id;
		this.addEditDataEx.status_id = 12;
		this.addEditDataEx.value = this.formData.value;
		this.addEditDataEx.lead_type = this.formData.lead_type;
      	this.addEditDataEx.customs = customData;
 		this.addEditDataEx.owner_id = this.formData.owner_id;
		
		
		
		
		
		
		
		
		if (this.formData.activity_done) {
          this.addEditData.value = 0;
        }
      
		
		
		
		
      this.addEditData.pipeline_id = this.formData.pipeline_id;
      
      this.addEditData.owner_id = this.formData.owner_id;
      this.addEditData.expired_at = this.formData.expired_at ? moment(this.formData.expired_at).format(
        "YYYY-MM-DD"
      ) : null;
      api
        .route("crm/statuses")
        .params({name: "status_won", type: "deal"})
        .get()
        .then((response) => {
          this.addEditData.status_id =
            collect(response).first().id ?? this.formData.status_id;
		  
		
        
		if (this.formData.qty == 2) {this.save(this.addEditData); this.save(this.addEditData);
      	} else if (this.formData.qty == 3){this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData);
		} else if (this.formData.qty == 4){this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData);
	  	} else if (this.formData.qty == 5){this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData);
	  	} else if (this.formData.qty == 6){this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData);
	  	} else if (this.formData.qty == 7){this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData);
	  	} else if (this.formData.qty == 8){this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData);
	  	} else if (this.formData.qty == 9){this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData);
	  	} else if (this.formData.qty == 10){this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData);
	  	} else if (this.formData.qty == 11){this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData);
	  	} else if (this.formData.qty == 12){this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData);
	  	} else if (this.formData.qty == 13){this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData);
	  	} else if (this.formData.qty == 14){this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData);
	  	} else if (this.formData.qty == 15){this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData);
	  	} else if (this.formData.qty == 16){this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData);
	  	} else if (this.formData.qty == 17){this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData);
	  	} else if (this.formData.qty == 18){this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData);
	  	} else if (this.formData.qty == 19){this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData);
	  	} else if (this.formData.qty == 20){this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData);
	  	} else if (this.formData.qty == 21){this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData);
	  	} else if (this.formData.qty == 22){this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData);
	  	} else if (this.formData.qty == 23){this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData);
	  	} else if (this.formData.qty == 24){this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData);
	  	} else if (this.formData.qty == 25){this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData);
	  	} else if (this.formData.qty == 26){this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData);
	  	} else if (this.formData.qty == 27){this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData);
	  	} else if (this.formData.qty == 28){this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData);
	  	} else if (this.formData.qty == 29){this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData);
	  	} else if (this.formData.qty == 30){this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData); this.save(this.addEditData);
	  	} else {
	  		this.save(this.addEditData);
	  		
	  	}
		  
		  if(this.formData.pipeline_id == 7){
		  this.save(this.addEditDataEx);
		}
		  
        });
		 
    },
    afterError(response) {
      this.loading = false;
      this.errors = response.data.errors;
    },
    afterSuccess(response) {
      this.$store.dispatch("getDeal");
      this.$toastr.s(response.data.message);
      this.$hub.$emit("reload-" + this.tableId);
      this.$emit("saved");
      this.$hub.$emit("deal-update-list");
      this.closeModal();
    },
    afterFinalResponse() {
      this.loading = false;
    },
    afterSuccessFromGetEditData(response) {
      	this.formData = response.data;
		this.formData.person_id = this.formData.contact_person[0].id;
	  this.formData.fund_id = this.formData.contact_fund[0].id;
      let expired_at = response.data.expired_at.split(" ");
      this.formData.expired_at = new Date(expired_at);
      this.getAllCustomFields("deal");
    },
    closeModal(value) {
      this.$emit("close-modal", value);
    },
    getPipeline() {
      this.axiosGet("crm/pipelines")
        .then((response) => {
          this.pipelineList = this.collection(response.data.data).shaper(
            "name"
          );
          if (!this.formData.pipeline_id) {
            this.formData.pipeline_id = response.data.data[0].id;
          }
        })
        .catch(({error}) => {
        });
    },
    getStages() {
      this.axiosGet("crm/stages?all")
        .then((response) => {
          this.stageList = collect(response.data).where('pipeline_id', this.formData.pipeline_id).sortBy('priority').get();
          this.stageId = this.stageList.find(
            (v) => v.pipeline_id == this.formData.pipeline_id
          );

          this.dataLoaded = true;
        })
        .catch(({error}) => {
        });
    },
    setStageId(index) {
      if (this.stageListAsPipelineId.length) {
        this.formData.stage_id = this.stageListAsPipelineId[index].id;
      }
    },
    changeLeadType(){
      this.formData.contextable_id = null;
    }
  }
};
</script>
